// Deterministic support-request endpoints (SGL-141 companion) — unlike the
// send_support_ticket agent tool (which depends on the model deciding to
// call it), these always fire when a UI button is clicked.
import { authedFetch } from "../auth/authedFetch";
import { CHAT_API_BASE_URL } from "./chatService";

export async function requestReputationManagerSetup(
  customerId: string,
  idToken: string,
  hasGhl: boolean,
): Promise<void> {
  if (!CHAT_API_BASE_URL) {
    throw new Error("Chat API is not configured (REACT_APP_CHAT_API_BASE_URL)");
  }
  const base = CHAT_API_BASE_URL.replace(/\/$/, "");
  const resp = await authedFetch(
    `${base}/support/reputation-manager`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customer_id: customerId, has_ghl: hasGhl }),
    },
    idToken,
  );
  if (!resp.ok) {
    throw new Error(`Support request failed (${resp.status})`);
  }
}
